export default function RnRLogo({ className = '' }) {
  return (
    <img
      src="/logo.png"
      alt="Rock'n'Rhein Festival Logo"
      className={`object-contain ${className}`}
    />
  );
}
